import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Button, Empty, Space, Select, InputNumber } from "antd";

import { Bar } from "@ant-design/charts";

import moment from "moment";
import { chain } from "lodash";
import { ReloadOutlined } from "@ant-design/icons";

import { getLeastWeldHoursList } from "../../features/performance/performanceSlice";

import PickerWithType from "../../libs/components/PickerWithType";
import SelectDateType from "../../libs/components/SelectDateType";
import { GetDateRange, normalizeRobotName } from "../../libs/utils";

const today = moment();
const lastWeek = moment().subtract(7, "days");

function LeastWeldHours(props) {
  const dispatch = useDispatch();
  const least_weld_hours =
    useSelector((state) => state.performance.least_weld_hours) || [];

  const [dateValues, setDateValues] = useState(null);
  const [selectedValues, setSelectedValues] = useState(null);
  const [filterValue, setFilterValue] = useState(4);
  const [type, setType] = useState("range");

  useEffect(() => {
    dispatch(
      getLeastWeldHoursList(null, {
        start: lastWeek.format("YYYY-MM-DD"),
        end: today.format("YYYY-MM-DD"),
      })
    );
  }, [dispatch]);

  const data =
    !!least_weld_hours && least_weld_hours.length > 0
      ? chain(least_weld_hours)
          .groupBy("robot_id")
          .map((value, index) => ({
            id: index,
            value: value.reduce(
              (prev, curr) =>
                moment.duration(prev).add(moment.duration(curr.value)),
              moment.duration()
            ),
          }))
          .map((item) => ({
            ...item,
            weld_time: moment.duration(item.value).asHours(),
          }))
          .filter((item) =>
            filterValue ? item.weld_time <= filterValue : item.weld_time
          )
          .value()
          .sort((a, b) => b.weld_time - a.weld_time)
      : [];

  return (
    <>
      <Space>
        <b>Least Weld Hours</b>

        <SelectDateType value={type} onChange={setType}></SelectDateType>
        <PickerWithType
          type={type}
          defaultValue={[lastWeek, today]}
          onChange={(value) => setDateValues(value)}
        />
        <Button
          disabled={!dateValues}
          onClick={() => {
            const dateRange = GetDateRange(type, dateValues);

            dispatch(
              getLeastWeldHoursList(null, {
                start: dateRange[0],
                end: dateRange[1],
              })
            );
          }}
          icon={<ReloadOutlined />}
        ></Button>

        <InputNumber
          defaultValue={filterValue}
          onChange={(value) => setFilterValue(value)}
          min={0}
        ></InputNumber>

        <Select
          style={{ minWidth: 200 }}
          mode="multiple"
          placeholder="Filter by SWR number"
          options={data
            .map((item) => item.id)
            .filter((v, i, a) => a.indexOf(v) === i)
            .map((id) => ({
              label: normalizeRobotName(id),
              value: id,
            }))}
          onChange={(values) => {
            setSelectedValues(values);
          }}
        ></Select>
      </Space>

      <div>
        {least_weld_hours && least_weld_hours.length > 0 ? (
          <Bar
            {...{
              data:
                !selectedValues || selectedValues.length === 0
                  ? data
                  : data.filter((v, i, a) => {
                      return selectedValues.includes(v.id);
                    }),
              xField: "weld_time",
              yField: "id",
              color: "#1890ff",
              barWidthRatio: 0.9,
              maxBarWidth: 20,
              label: {
                position: "middle",
                formatter: function (v) {
                  return moment.duration(v.value).asHours().toFixed(1);
                },
              },
              xAxis: {
                label: {
                  formatter: function formatter(v) {
                    return moment.duration({ hours: v }).asHours().toFixed(1);
                  },
                },
              },
              yAxis: {
                label: {
                  formatter: function formatter(v) {
                    return normalizeRobotName(v);
                  },
                },
              },
              tooltip: {
                title: (v) => normalizeRobotName(v),
                formatter: (datum) => {
                  return {
                    name: normalizeRobotName(datum.id),
                    value:
                      datum.weld_time &&
                      moment
                        .duration({ hours: datum.weld_time })
                        .asHours()
                        .toFixed(1) + " hours",
                  };
                },
              },
            }}
          />
        ) : (
          <Empty />
        )}
      </div>
    </>
  );
}
export default LeastWeldHours;
